let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cVUuJ")).then(() => parcelRequire('6fCl5'));